var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWritingWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 128",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Sexsocial logo white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Sexsocial wordmark for dark backgrounds with white and coral lettering.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whiteAccent",
    x1: 34,
    y1: 26,
    x2: 96,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9cb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff6a86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea3f65"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-10%",
    y: "-20%",
    width: "120%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 10,
    floodColor: "#ff6b87",
    floodOpacity: 0.16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 108,
    height: 108,
    rx: 30,
    fill: "#ffffff",
    fillOpacity: 0.08,
    stroke: "#ffffff",
    strokeOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 37,
    r: 6,
    fill: "#ffb0c0",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#whiteAccent)",
    d: "M66.7 31c11.1 0 19.9 5.2 23.3 13.6l-13.7 3c-2.1-4.4-5.6-6.2-10.8-6.2-5.7 0-9.3 2.3-9.3 6.2 0 4.2 3.4 5.6 13.4 7.3 14.1 2.5 23.3 7.6 23.3 20.7 0 13.9-11.5 22.4-28.2 22.4-15.1 0-25.1-6-29.1-16.8l14.1-2.8c2.7 5.7 7.2 8.2 15.3 8.2 7.6 0 12-2.6 12-6.9 0-4.3-3.3-5.7-13.7-7.6-14.8-2.7-22.9-8.1-22.9-20.6 0-12.9 10.8-20.5 26.3-20.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 83,
    fill: "#ffffff",
    fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
    fontSize: 74,
    fontWeight: 800,
    letterSpacing: -3
  }, "\n      Sex\n    "), /*#__PURE__*/React.createElement("text", {
    x: 259,
    y: 83,
    fill: "#ff6a86",
    fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
    fontSize: 74,
    fontWeight: 800,
    letterSpacing: -3
  }, "\n      social\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWritingWhite);
export default __webpack_public_path__ + "static/media/logo-with-writing-white.17eca33458ceb5de4d3607143dec716b.svg";
export { ForwardRef as ReactComponent };